import { SectionHead } from '../components/SectionHead';
import { useSeo } from '../lib/seo';

const ARTICLES = [
  {
    art: 'FSMA s.19 — General Prohibition',
    h: 'We sit outside the perimeter, on purpose.',
    body: 'Section 19 of the Financial Services and Markets Act 2000 prohibits anyone from carrying on a "regulated activity" in the UK unless they are authorised or exempt. Omega Trade is neither authorised nor purports to carry on regulated activity. Every service is structured as research, document preparation, management consultancy, or pure introducer activity falling within the exempt categories below.',
  },
  {
    art: 'RAO Article 15 — Introducing',
    h: 'Pure introducer activity.',
    body: 'Where Omega refers a corporate client to an authorised firm (a bank, regulated lender, FCA-authorised broker), our role is limited to the introduction itself — without advice on the merits, without collecting documents into the regulated firm, and without remuneration that re-characterises the activity.',
  },
  {
    art: 'RAO Article 29 — Arranging through authorised persons',
    h: 'No money, no advice, no arranging.',
    body: 'Where introductions might otherwise be characterised as "arranging deals in investments," they remain exempt under Article 29 because (a) the deal is entered with or through an authorised person, (b) Omega does not give advice on the merits, and (c) Omega does not receive client money.',
  },
  {
    art: 'FSMA s.21 — Financial Promotions',
    h: 'B2B-only, FPO-exempt communications.',
    body: 'All Omega communications are restricted under the Financial Promotion Order to recipients who self-certify as body corporates that meet the "investment professional" or "high net worth body corporate" exemptions. We do not communicate financial promotions to retail consumers.',
  },
];

export function Regulatory() {
  useSeo({
    title: 'Regulatory position — Omega Trade and Finance',
    description: 'How Omega Trade stays unregulated by design — FSMA s.19, RAO Articles 15 & 29, FPO s.21 framing in plain English. Body-corporate only. No client money. No investment advice.',
    canonicalPath: '/regulatory',
  });
  return (
    <main>
      <section className="section" style={{ paddingBottom: 0 }}>
        <div className="container">
          <span className="eyebrow">Regulatory position</span>
          <h1 style={{ fontSize: 'clamp(40px, 6vw, 72px)', letterSpacing: '-0.025em', marginTop: 18, maxWidth: '18ch' }}>
            How Omega Trade stays unregulated, in plain English.
          </h1>
          <p className="lead" style={{ marginTop: 18, maxWidth: '64ch' }}>
            We publish this in detail because clarity protects both you and us. If you read
            something here that doesn’t match how an Omega engagement actually runs, tell us
            immediately — your brief should not proceed.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="reg-grid">
            {ARTICLES.map((a) => (
              <div key={a.art} className="card reg-card">
                <div className="article">{a.art}</div>
                <h3>{a.h}</h3>
                <p style={{ marginTop: 12 }}>{a.body}</p>
              </div>
            ))}
          </div>

          <SectionHead num="—" label="Operating commitments" title="Eight commitments we make on every brief." />
          <ul className="checklist">
            <li>Services are offered exclusively to body corporates (Limited Companies, PLCs, LLPs).</li>
            <li>Every brief requires sophisticated-investor / HNW corporate self-certification.</li>
            <li>Omega never holds client money. Payments to authorised counterparties flow direct.</li>
            <li>Omega does not advise on the merits of any specific investment, instrument or deal.</li>
            <li>Communications are framed as consultancy, research and introduction — never solicitation.</li>
            <li>Invoices reference consultancy / research / introduction fees, not "deposits" or "escrow".</li>
            <li>KYC / AML obligations under MLR 2017 apply to Omega and are met for every client.</li>
            <li>UK counsel reviews our Terms of Business and every new service line before launch.</li>
          </ul>

          <div
            style={{
              marginTop: 56, padding: 28,
              border: '1px solid var(--rule)', borderRadius: 'var(--r-lg)',
              background: 'var(--bg-soft)',
              fontSize: 13.5, color: 'var(--fg-soft)', lineHeight: 1.6,
            }}
          >
            <strong style={{ color: 'var(--fg)' }}>Important.</strong> This page is a plain-English description of our regulatory position;
            it is not legal advice and is not a substitute for your own counsel. If your engagement
            evolves in a direction that would require regulated permissions, we will pause work,
            refer you to authorised counterparties and refund any fees attributable to the regulated
            activity. Under no circumstances will Omega proceed on an unauthorised basis.
          </div>
        </div>
      </section>
    </main>
  );
}
